import React from 'react';

/**
 * Monnaie officielle de l'application : USDT (Tether).
 * 1 USDT = 1 USD — aucun taux de conversion, uniquement de l'affichage.
 */

// Formate le nombre seul (ex: "12,450.80").
// Les très petits prix (ex: SHIB 0.0000044) gardent leurs décimales
// significatives au lieu d'afficher "0.00".
const formatNumber = (value, minDecimals = 2) => {
  const num = parseFloat(value) || 0;
  const maxDecimals = num !== 0 && Math.abs(num) < 0.01 ? 8 : Math.max(2, minDecimals);
  return new Intl.NumberFormat('en-US', {
    minimumFractionDigits: minDecimals,
    maximumFractionDigits: maxDecimals
  }).format(num);
};

/**
 * Version TEXTE — pour les contextes chaîne (messages, logs).
 * Ex: "12,450.80 USDT"
 */
export const formatUSDT = (value, minDecimals = 2) =>
  `${formatNumber(value, minDecimals)} USDT`;

/**
 * Version JSX — pour l'affichage: le sigle USDT est rendu plus petit
 * et discret que le montant (style plateforme crypto).
 * Ex: 12,450.80 ᵁˢᴰᵀ — stylé via la classe globale .usdt-unit
 */
export const usdt = (value, minDecimals = 2) => (
  <span className="usdt-amount">
    {formatNumber(value, minDecimals)}
    <span className="usdt-unit">USDT</span>
  </span>
);

export default formatUSDT;
